import React, { useEffect, useCallback, useState} from 'react';
import {DOT, DASH, VARIABLE} from 'effects/midi/tidal/types.js';
import {
    applyToLeaf,
    applyRule,
    before,
    after,
    when ,
    REGULAR,
    otherwise,
    ACCENT,
    FLAM,
    STACCATO,
    DOUBLE,
    REST,
    LEGATO,
    PIANO,
    PIANISSIMO
} from 'effects/midi/scripting/trules.js';
import {connect} from 'react-redux';

const CellInner = ({cell}) => { 
    let text = '';
    switch (cell.type || cell) {
    case DOT: 
        text = (<div className="symbol dot"/>);
        break;
    case DASH:
        text = (<div className="symbol dash"/>);
        break;
    case false:
        break;
    default:
        let _type = cell.type || cell;
        text = (<div className={"symbol " + _type.toLowerCase()}/>);
        break;
    }
    return text;
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CellInner);
